<template>
  <el-dialog
    :title="data.Baslik"
    :visible.sync="ModalOlayi"
    center
    width="50%">
    <a @click="ModalKapat" class="ModalKapat"><i class="el-icon-close"></i></a>
    <el-form :model="data" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="No" prop="kNo">
            <el-input v-model="data.kNo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Kat" prop="Kat">
            <el-input v-model="data.Kat"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="M2" prop="m2">
            <el-input v-model="data.m2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Mesken Türü" prop="Mesken_Turu_id">
            <el-select v-model="data.Mesken_Turu_id" filterable>
              <el-option
                v-for="item in Mesken_Turu"
                :key="item.id"
                :label="item.Tanim"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

      </el-row>
      <el-collapse accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <el-tooltip class="item" effect="dark" content="Borçlandırma aşamasında indirimler listesi"
                        placement="top">
              <i class="el-icon-info text-primary cursor-pointer"></i>
            </el-tooltip>
            Mesken İndirim
          </template>
          <el-row :gutter="24">
            <el-col :span="4">
              <el-form-item label="Tanım" prop="Tanim">
                <el-input v-model="Indirim.Tanim"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="Oran" prop="Oran">
                <el-input v-model="Indirim.Oran" maxlength="2"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  collapse-tags
                  :options="Kategoriler"
                  v-model="Indirim.Kategori_id"
                  filterable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="Başlama Tarihi" prop="basTarihi">
                <el-date-picker
                  v-model="Indirim.basTarihi"
                  type="date"
                  placeholder=""
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="Bitiş Tarihi" prop="bitTarihi">
                <el-date-picker
                  v-model="Indirim.bitTarihi"
                  type="date"
                  placeholder=""
                  format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button @click="IndirimEkle" class="btn-block mt-4" size="small" type="primary"><i
                class="el-icon-plus"></i></el-button>
            </el-col>
            <div v-for="(Indirim,index) in data.IndirimListe">
              <el-col :span="4">
                <el-form-item label="Tanım" prop="Tanim">
                  <el-input v-model="Indirim.Tanim"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="Oran" prop="Oran">
                  <el-input v-model="Indirim.Oran" maxlength="2"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Kategori" prop="Kategori_id">
                  <el-cascader
                    collapse-tags
                    :options="Kategoriler"
                    v-model="Indirim.Kategori_id"
                    filterable></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Başlama Tarihi" prop="basTarihi">
                  <el-date-picker
                    v-model="Indirim.basTarihi"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="Bitiş Tarihi" prop="bitTarihi">
                  <el-date-picker
                    v-model="Indirim.bitTarihi"
                    type="date"
                    placeholder=""
                    format="dd.MM.yyyy">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-button @click="data.IndirimListe.splice(index, 1)" class="btn-block mt-4" size="small"
                           type="danger"><i
                  class="el-icon-minus"></i></el-button>
              </el-col>
            </div>
          </el-row>
        </el-collapse-item>
      </el-collapse>


    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="medium" @click="Submit()"
                 icon="el-icon-check">{{$t('eGenel.0')}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      ModalOlayi: Boolean,
      data: {
        type: Object,
        require: true,
      },
    },
    data() {
      return {
        FormHata: {
          kNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kat: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          m2: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Mesken_Turu_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}]
        },

        Indirim: {
          Kategori_id: null,
          Tanim: null,
          Oran: 0,
          basTarihi: null,
          bitTarihi: null
        },
        Kategoriler: [],
        Mesken_Turu: [],
      }
    },
    methods: {
      ModalKapat() {
        this.$emit('ModalOlayi', false)
      },
      IndirimEkle() {
        if (!this.Indirim.Kategori_id) {
          this.IndirimHata = true;
          this.$message.error("Kategori Seçiniz");
        }
        if (!this.Indirim.Tanim) {
          this.IndirimHata = true;
          this.$message.error("Tanım yazınız");
        }
        if (this.Indirim.Tanim && this.Indirim.Kategori_id) {
          this.data.IndirimListe.push({
            id: null,
            Kategori_id: this.Indirim.Kategori_id,
            Tanim: this.Indirim.Tanim,
            Oran: this.Indirim.Oran,
            basTarihi: this.Indirim.basTarihi,
            bitTarihi: this.Indirim.bitTarihi,
          });
          this.Indirim = {
            Kategori_id: null,
            Tanim: null,
            Oran: 0,
          }
        }

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {

          if (valid) {
            if (this.data.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.data,
                path: 'yonetim/mesken/' + this.data.id
              })
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();

                  } else {

                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;

                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.data, path: 'yonetim/mesken'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.$emit("ModalOlayi", false);
                    this.$message.success(response.Mesaj);
                    this.$router.push("/yonetim/mesken/" + response.Mesken_id);
                    //this.SayfaYukle();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Kategoriler = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.$store.dispatch("Get", {path: 'yonetim/sirket/meskenturu'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Mesken_Turu = response.Liste;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      }

    },
    created() {
      this.SayfaYukle();
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/mesken/MeskenDetay.vue